import { cn } from '@/shared/lib/utils'

export const Card = ({ children, className = '', ...rest }) => (
  <div
    id="level-play-card"
    className={cn(
      'mx-auto relative rounded-3xl my-[30px]',
      'flex items-stretch justify-center',
      'bg-white shadow-[0px_8px_0px_var(--color-primary),_0px_0px_25px_rgba(136,0,134,0.8),inset_0_4px_0px_#FDF5FF]',
      className
    )}
    style={{
      aspectRatio: '2 / 3',

      // Não ultrapassa a viewport (largura/altura)
      maxWidth: '90vw',
      // use dvh/svh para mobile; se não suportar, o maxHeight abaixo com vh cobre
      maxHeight: '90dvh',

      // Escolhe automaticamente o limitador “apertado”
      // - se a tela for larga, limita pela altura (2/3 de 90dvh)
      // - se for alta/estreita, limita pela largura
      width: 'min(90vw, calc(90dvh * (2 / 3)))',
      height: 'min(90dvh, calc(90vw * (3 / 2)))',

      // fallback pra browsers sem dvh (Safari iOS antigos)
      // (propriedade repetida: a última “vence” se suportada)
      ...(typeof window === 'undefined'
        ? {}
        : {
            maxHeight: '90vh',
            width: 'min(90vw, calc(90vh * (2 / 3)))',
            height: 'min(90vh, calc(90vw * (3 / 2)))'
          }),

      transition: 'all 0.2s ease-in-out'
    }}
    {...rest}
  >
    <div
      id="level-play-wrapper"
      className="grid w-full h-full grid-rows-[auto_auto_minmax(0,1fr)_auto]"
    >
      {children}
    </div>
  </div>
)
